import React from 'react';
import { LucideIcon } from '../LucideIcon';

export const OrderCardError = () => {
  return (
    <div className="flex flex-col w-full bg-generic-0 border border-neutral-100 rounded-[8px] p-6 gap-3 items-center justify-center min-h-[200px]">
      <div className="flex flex-col gap-2 items-center">
        <LucideIcon name="PackageSearch" size={48} className="text-neutral-400" />
        <p className="text-label-medium font-medium text-neutral-700 text-center">Order Not Found</p>
        <p className="text-paragraph-small font-normal text-neutral-400 text-center max-w-[300px]">
          We couldn&apos;t find any order with this Order ID. Please verify your Order ID and try again.
        </p>
      </div>
    </div>
  );
};
